(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tt/assets/javascripts/views/tt-navigation-view.js') >= 0) return;  svs.modules.push('/modules/tt/assets/javascripts/views/tt-navigation-view.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.tt.views.TTNavigation = Marionette.View.extend({

    className: 'tt-navigation-bar padding-1',

    template: function(data) {
      return svs.tt.templates.navigation(data);
    },

    events: {
      'click .js-product-link': 'productLink'
    },

    productLink: function(data) {
      svs.tt.router.navigate(
        'matchlist/' + data.currentTarget.attributes['data-id'].value,
        { trigger: true }
      );
    }
  });
})(Backbone, _, svs);


 })(window);